import s from "../People/People.module.css";
import {useEffect, useState} from "react";
import {_axios} from "../../axios/_axios";
import {useParams} from 'react-router-dom'

const People = () => {
  const {id} = useParams();
  const [data, setData] = useState();

  useEffect(
    () => {
      _axios.get('/people/' + id)
        .then(({data}) => {
          setData(data)
        })
        .catch(e => {
          console.log(e)
        })
    }, [id]);

  return (
    <div>
      <div className={s.main}>
        <h1 className={s.fio}>{data?.fName + ' ' + data?.sName}</h1>
        <div className={s.desc}>
          <div>
            <div className={s.left_text} dangerouslySetInnerHTML={{__html: data?.desc}}></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default People;
